// extracted by mini-css-extract-plugin
module.exports = {"title":"CredentialsSelectModal_title_2cgg1","subtitle":"CredentialsSelectModal_subtitle_31FVi"};